import React, { useState } from 'react';
import {
  Modal,
  AsyncKovResourcePicker,
  useLoadSriOptions,
} from '@kathondvla/react-shared-components/src/components';
import { contentApi } from '@store/api/apiConfig';
import { Concordantie } from '@UI/aside/asideConcordanties/asideConcordantiesSelectors';

export interface OdetModalProps {
  onClose?: () => void;
  onSubmit?: (response: { odet: Concordantie | undefined }) => void;
  concordantie?: Concordantie;
}
const OdetModal: React.FC<OdetModalProps> = ({ onClose = () => {}, onSubmit, concordantie }) => {
  const [selectedOdet, setSelectedOdet] = useState(concordantie);

  const sriLoadOptions = useLoadSriOptions({
    sriClient: contentApi,
    href: '/content',
    parameters: { typeIn: 'CURRICULUM_ODET' },
  });

  const changeOdet = (value) => {
    setSelectedOdet(value);
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({
        odet: selectedOdet,
      });
      onClose();
    }
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title="Voeg gerelateerd document toe" onClose={onClose} />
      <Modal.Body>
        <div className="form-group">
          <AsyncKovResourcePicker
            value={selectedOdet}
            loadOptions={sriLoadOptions}
            clearable={false}
            localData={true}
            onChange={(value) => changeOdet(value.$$expanded)}
            placeholder="Zoek een item"
            multiple={false}
            menuPlacement="bottom"
            optionValue={(o) => o.key}
            optionTemplate={(o) => (o.$$expanded ? o.$$expanded.title : o.title)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Ok
        </button>
      </Modal.Footer>
    </div>
  );
};

OdetModal.displayName = 'OdetModal';

export default OdetModal;
